import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '5%',
      backgroundColor: '#F2F2F2',
    },
    rootCard: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 15,
        width: '100%',
      },
      backgroundColor: '#fff',
      width: '40%',
      paddingTop: 10,
      display: 'flex',
      flexFlow: 'column',
      alignContent: 'space-around',
      alignItems: 'center',
      textAlign: 'center',
      boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.25)',
      marginTop: 25,
    },
    divider: {
      marginTop: 10,
      marginBottom: 10,
      width: '100%',
      height: 4,
      backgroundColor: Colors.secundary,
      borderRadius: 18,
    },
    rootForm: {
      margin: theme.spacing(1),
      display: 'flex',
      flexFlow: 'column wrap',
    },
    rootButton: {
      width: '30%',
      height: 33,
      marginBottom: 10,
      backgroundColor: Colors.secundary,
      color: 'white',
      fontWeight: 'bold',
      alignSelf: 'center',
      border: 'none',
      '&:hover': {
        backgroundColor: '#007F93',
      },
    },
    logo: {
      width: '250px',
      margin: '4.5% 0 7.5% 0',
      [theme.breakpoints.down('sm')]: {
        width: '100px',
      },
    },
    logoamc: {
      width: '250px',
      margin: '5% 0 8% 0',
      [theme.breakpoints.down('sm')]: {
        width: '100px',
      },
    },
    link: {
      color: '#007F93',
      transition: 'color 0.3s',
      '&:hover': {
        color: Colors.main,
      },
    },
    paper: {
      padding: theme.spacing(1),
    },
  }),
);
